module.exports = __webpack_public_path__ + "img/pr-2.57b39f2b.png";